import { useState } from "react";
import debounce from "lodash/debounce";
import { useFetchSection } from "./useFetchSection";
import { useFetchSections } from "./useFetchSections";

export interface Section {
  course_name: string;
  id: string;
  name: string;
}

const sectionsOptionFormatter = (section: Section) => ({
  label: section.name,
  value: section.id,
  description: section.course_name,
});

export const useSectionSelector = ({
  selectedSectionId,
}: {
  selectedSectionId: string;
}) => {
  const [sectionName, setSectionName] = useState("");
  const { data, isLoading: isLoadingSections } = useFetchSections({
    name: sectionName,
  });
  const {
    data: section,
    isLoading: isLoadingSection,
    isSuccess: isSectionLoaded,
  } = useFetchSection({
    sectionId: selectedSectionId,
  });
  const sections = (data as { records: Section[] })?.records ?? [];

  const sectionOptions = sections.map(sectionsOptionFormatter);

  if (section && !isLoadingSection && isSectionLoaded) {
    sectionOptions.push(sectionsOptionFormatter(section as Section));
  }

  const handleSectionTitleChange = debounce(
    (title: string) => setSectionName(title),
    500,
  );

  return {
    isLoading: isLoadingSections || isLoadingSection,
    sectionOptions,
    handleSectionTitleChange,
  };
};
